module.exports = __webpack_public_path__ + "files/94de034560eceb6a03a6a793607197fc.png";